import { CircularProgress, TableCell, TableRow } from 'app/ui'

type TableRowLoadingProperties = {
    colSpan: number
}

export const TableRowLoading = ({
    colSpan,
}: Readonly<TableRowLoadingProperties>): JSX.Element => {
    return (
        <TableRow>
            <TableCell colSpan={colSpan}>
                <CircularProgress isIndeterminate />
            </TableCell>
        </TableRow>
    )
}
